<template>
  <div class="data-push-item">
    <div class="">
      <el-checkbox v-model="openDataPush">数据推送</el-checkbox>
      <div v-if="openDataPush" class="childPageSettingBtn mt12" @click="showDialogForDataPush = true">
        <span class="icon icon-portal-setting1"></span>
        <span>配置数据推送</span>
      </div>
    </div>
    <!--数据推送设置弹框 -->
    <el-dialog
        title="配置数据推送"
        :visible.sync="showDialogForDataPush"
        :modal-append-to-body="false"
        custom-class="dataPushDialog"
    >
      <div class="verticallyCenter">
        <span class="width76 mr24">接口地址</span>
        <el-input
            class="flex1"
            v-model="interfacePushRule.url"
            placeholder="请输入https://或http://开头的链接地址
"
        ></el-input>
      </div>
      <div class="mt16 verticallyCenter">
        <span class="width76 mr24">触发条件</span>
        <el-checkbox v-model="newDataToPush" :label="1">新增数据时</el-checkbox>
        <el-checkbox v-model="editDataToPush" :label="2">修改数据时</el-checkbox>
      </div>
      <div class="mt16 verticallyCenter">
        <span class="width76 mr24">推送内容</span>
        <el-radio-group v-model="interfacePushRule.method">
          <el-radio :label="0" class="mr24">全部数据</el-radio>
          <el-radio :label="1">置顶数据</el-radio>
        </el-radio-group>
      </div>
      <div class="mt16 verticallyCenter push-history-link" @click.stop="toDataPushPage">
        <span class="mr2">查看推送记录</span>
        <span class="icon-portal-right-up fs14"></span>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showDialogForDataPush = false">取 消</el-button>
        <el-button size="small" type="primary" @click="updateDataPushSet">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { isExist } from "@/utils/index"
export default {
  name: "dataPush",
  props: {
    options: { type: Object },

  },
  data() {
    return {
      showDialogForDataPush: false,
      interfacePushRule: {
        addAndUpdateRule: "", //1表示新增时，2表示修改时
        engineInstanceId: this.options.engineInstanceId_10, //对应应用的engineInstanceId
        id: null, //有则修改，为空为新增
        method: 0, //0表示全部数据，1表示置顶数据
        pushType: "1", //推送置接口固定为1
        status: this.options.openDataPush, //true开启推送，false关闭
        url: ""
      },
      editDataToPush: false,
      newDataToPush: false,
    }
  },
  computed: {
    ids() {
      const ids = this.$store.state.states.activeID
      if (isExist(ids.swiperContent_id)) {
        // 删除轮播单元格id
        delete ids.swiperContent_id
      }
      return ids
    },
    openDataPush: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "openDataPush", "openDataPush", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "openDataPush", false, null, this.ids)
      }
    },
  },
  watch:{
    openDataPush(newVal, o) {
      this.interfacePushRule.status = newVal
      this.updateDataPushSet()
    },
    editDataToPush(newVal, oldVal) {
      let dot = this.newDataToPush && this.editDataToPush ? "," : ""
      this.interfacePushRule.addAndUpdateRule = `${this.newDataToPush ? "1" : ""}${dot}${
          this.editDataToPush ? "2" : ""
          }`
    },
    newDataToPush(newVal, oldVal) {
      let dot = this.newDataToPush && this.editDataToPush ? "," : ""
      this.interfacePushRule.addAndUpdateRule = `${this.newDataToPush ? "1" : ""}${dot}${
          this.editDataToPush ? "2" : ""
          }`
    },
  },
  created(){
    this.getDataPushData()
  },
  methods:{
    async getDataPushData() {
      if (!this.options.engineInstanceId_10) {
        return
      }
      let res = await this.$API.getDataPushRule({
        engineInstanceId: this.options.engineInstanceId_10
      })
      if (res.data.code === 1 && res.data.data?.interfacePushRule) {
        let data = res.data.data.interfacePushRule
        this.interfacePushRule.addAndUpdateRule = data.addAndUpdateRule
        this.interfacePushRule.engineInstanceId = data.engineInstanceId
        this.interfacePushRule.id = data.id
        this.interfacePushRule.method = data.method
        this.interfacePushRule.pushType = data.pushType
        this.interfacePushRule.status = data.status
        this.interfacePushRule.url = data.url
        this.editDataToPush = this.interfacePushRule.addAndUpdateRule.indexOf("2") > -1 ? true : false
        this.newDataToPush = this.interfacePushRule.addAndUpdateRule.indexOf("1") > -1 ? true : false
      }
    },
    updateDataPushSet() {
      if (!this.openDataPush) {
        this.showDialogForDataPush = false
        // 未开启数据推动的时候无需保存
        return
      }
      this.$API
          .editDataPushRule({
            interfacePushRule: {
              ...this.interfacePushRule
            }
          })
          .then(res => {
            if (res.data.code === 1) {
              this.showDialogForDataPush = false
              console.log("修改成功")
              this.interfacePushRule.id = res.data.data.interfacePushRule.id
            }
          })
    },
    // 跳转到数据推送记录页面
    toDataPushPage() {
      window.open(`/engine2/admin/push-log/to-logs?engineInstanceId=${this.options.engineInstanceId_10}`, "_blank")
    },
  }
}
</script>

<style lang="scss" scoped>
  .childPageSettingBtn {
    background: var(--leftMenuBgColor);
    border: 1px solid var(--themeColor);
    border-radius: 4px;
    font-size: 13px;
    line-height: 18px;
    text-align: center;
    color: var(--themeColor);
    padding: 5px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    &:not(.disabledBtn):hover {
      background: var(--defaultButtonHover);
      cursor: pointer;
    }
    &.is_disabled {
      background: var(--defaultButtonHover);
    }
    .icon-portal-loading1 {
      display: inline-block;
      margin-right: 4px;
      transform: rotate(90deg);
      font-size: 14px;
      color: var(--topOperationAColor);
      vertical-align: middle;
      margin-top: -2px;
      animation: rotation 1s linear infinite;
      &:before {
        color: var(--topOperationAColor);
      }
    }
    &.disabledBtn {
      cursor: not-allowed;
      border: 1px solid var(--themeColorDisabled);
      color: var(--themeColorDisabled);
    }
  }
  .push-history-link {
    color: var(--themeColor);
    cursor: pointer;
  }
</style>
